import {
  SECURITY_GROUPS_RETRIEVAL_INITIATED,
  SECURITY_GROUPS_RETRIEVED,
  SECURITY_GROUPS_RETRIEVAL_FAILED
} from './security.action';

import {INITIAL_STATE} from './security.state';

export const SecurityGroupsReducer = (state = INITIAL_STATE, {type, payload}) => {
  switch (type) {
    case SECURITY_GROUPS_RETRIEVAL_INITIATED:
      return Object.assign({}, state, {
        retrieveInProgress: true
      });

    case SECURITY_GROUPS_RETRIEVED:
      return Object.assign({}, state, {
        groups: payload,
        retrieveInProgress: false
      });

    case SECURITY_GROUPS_RETRIEVAL_FAILED:
      return Object.assign({}, state, {
        retrieveInProgress: false,
        error: payload
      });

    default:
      return state;
  }
};
